import axios from '@/plugins/http'

export default function resetPassword (email) {
  const api = '/api/v1/users/reset-password'

  return axios.post(api, { email })
}
